import { CharacterStateBase } from './_stateLibrary';
import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';

export class CoverIdle extends CharacterStateBase implements ICharacterState {
    constructor(character: Character) {
        super(character);
        this.character.simulation.velocitySimulator.damping = 0.6;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.simulation.setArcadeVelocityTarget(0);
        this.playAnimation(CharacterAnimation.CoverIdle, 0.3);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.onDie();
    }
}
